import React, { useState } from 'react'
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
const Register = () => {
    const [data, setData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        password: "",
    });
    const navigate = useNavigate();

   

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        let imageFile;


        if (name === "image" && files.length > 0) {
            imageFile = files[0];
        }

        setData((prevData) => ({
            ...prevData,
            [name]: name === "image" ? imageFile : value,
        }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("firstname", data.firstname);
            formData.append("email", data.email);
            formData.append("phoneNumber", data.phoneNumber);
            formData.append("password", data.password);

            // Check if the image is correctly appended
            if (data.image) {
                formData.append("image", data.image); // Only append if image exists
            } else {
                console.log("No image file selected");
            }

            // Log FormData for debugging
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }

            const res = await axios.post(
              `${process.env.REACT_APP_API_URL}/signup`,
              formData
            );
            console.log(res,"res")
            toast.success(res.data.message);
            navigate("/");
        } catch (error) {
            console.log(error, "Error");
        }
    };

// ...............................................
    return (
        <>
            {/* <!-- Page Header Start --> */}
            <div class="container-fluid page-header mb-5 p-0" style={{ backgroundImage: "url(/img/carousel-bg-1.jpg)" }}>
                <div class="container-fluid page-header-inner py-5">
                    <div class="container text-center">
                        <h1 class="display-3 text-white mb-3 animated slideInDown">Register</h1>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb justify-content-center text-uppercase">
                                <li class="breadcrumb-item"><a href="#">Home</a></li>
                                <li class="breadcrumb-item"><a href="#">Pages</a></li>
                                <li class="breadcrumb-item text-white active" aria-current="page">Registert</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            {/* <!-- Page Header End --> */}


            {/* <!-- Contact Start --> */}
            <div class="container-xxl py-5">
                <div class="container">
                    <div class="text-center wow fadeInUp" data-wow-delay="0.1s">
                        <h6 class="text-primary text-uppercase">// Register Us //</h6>
                        <h1 class="mb-5">Register For More Options</h1>
                    </div>
                    <div class="row g-4">
                        <div class="col-md-12">
                            <div class="wow fadeInUp" data-wow-delay="0.2s">
                                <form onSubmit={handleSubmit} onChange={handleChange} >
                                    <div class="row g-3">
                                        <div class="col-md-6">
                                            <div class="form-floating">
                                                <input type="text" class="form-control" id="name" placeholder="Enter your full name (e.g., Priya Sharma)" 
                                                name="firstname"
                                               required/>
                                                <label for="name">Full Name</label>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-floating">
                                                <input type="email" class="form-control" id="email" placeholder="Enter your email (e.g., priya.sharma@gmail.com)" 
                                                 name="email"
                                                />
                                                <label for="email">Email Address</label>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-floating">
                                                <input type="number" class="form-control" id="phone" placeholder="Enter 10-digit mobile number (e.g., 9876543210)" 
                                                name="phoneNumber"
                                                />
                                                <label for="phone">Mobile Number</label>
                                            </div>
                                        </div>
                                       
                                        <div class="col-md-6">
                                            <div class="form-floating">
                                                <input type="password" class="form-control" id="password" placeholder="Create a strong password" 
                                                 name="password"
                                                />
                                                <label for="Password">Password</label>
                                            </div>
                                        </div>
                                       
                                       
                                        <div class="col-12">
                                            <button class="btn btn-primary w-100 py-3" type="submit">Register Now</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Contact End --> */}

        </>
    )
}

export default Register
